import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=2cbb974a&scoped=true&"
import script from "./Support.vue?vue&type=script&lang=js&"
export * from "./Support.vue?vue&type=script&lang=js&"
import style0 from "./Support.vue?vue&type=style&index=0&id=2cbb974a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbb974a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLinkSupport: require('/app/components/storyblok/ui/LinkSupport.vue').default})
